 const womensdata = {
    womensproductItems : [{
      id: "15",
         name: "Kurthis",
         description:  "Designer Kurthis ",
         price : "400",
         Image : "https://tse3.mm.bing.net/th?id=OIP.SX3kFxcgr5aPNm4_cTNF6gHaLH&pid=Api&P=0",
         instock : 7
     } ,
     {
         id: "16",
         name: "Women-Shirt",
         description:  "Trendy SHIRT",
         price : "700",
         Image : "https://tse4.mm.bing.net/th?id=OIP.ZjbXFmGv0TTGXd6XVeglHgHaJ4&pid=Api&P=0",
         instock : 4
     } ,
     {
         id: "17",
         name: "Pant",
         description:  "Cream Pant",
         price : "600",
         Image : "https://i5.walmartimages.com/asr/fe69aaa3-8a24-488e-af4c-7e2dd870b5df_1.f8ead08a78cbf97908f2c5cd467fbfed.jpeg",
         instock : 5
     } ,
     {
         id: "18",
         name: "T-shirt",
         description:  "New TREND T-shirt",
        price : "300",
         Image : "https://tse1.mm.bing.net/th?id=OIP.l8-9RVXcByRtuuQ3__BOyQHaJ4&pid=Api&P=0",
         instock : 2
     } ,
     {
         id: "19",
         name: "Full-Sleave",
         description:  "Premium Clothing",
         price : "500",
         Image : "https://tse2.mm.bing.net/th?id=OIP.Sq0FnAng9GN7sU3wtbFm9QHaIw&pid=Api&P=0",
         instock : 3
     } ,
     {
         id: "20",
         name: "Nike",
         description:  "Airforce",
         price : "1500",
         Image : "https://media.karousell.com/media/photos/products/2021/2/20/nike_air_force_1_triple_white_1613792637_605af056_progressive.jpg",
         instock : 5
     } ,
     {
         id: "21",
         name: "AirMax",
         description:  "Training Shoe",
         price : "250",
         Image : "https://tse4.mm.bing.net/th?id=OIP.U4k9N_4XalOj4pjtk1WKLAHaE8&pid=Api&P=0",
         instock : 7
     } ]}

export default womensdata    
